const { BASE_URL } = require("./client");

const GET_MEMBERS = BASE_URL+ "/membership/dashboard/";
const DELETE_MEMBERSHIP = BASE_URL + "/membership/";

export {
    GET_MEMBERS ,
    DELETE_MEMBERSHIP,
};